import React from 'react';
import Telemedicine from './Telemedicine';
import Insurances from './Insurances';
import OfficePolicy from './OfficePolicy';

const OfficeInfo = () => {
    return (
        <>
        <Telemedicine/>
        <Insurances />
        <OfficePolicy />
        </>
    )
}

export default OfficeInfo;
